import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import {
  PATH_TO_CONTENT_STATS_STATE,
  PATH_TO_COURSE_STATS_STATE,
  PATH_TO_SECTION_STATS_STATE,
  PATH_TO_USER_STATS_STATE
} from "./consts";
import contentStatsReducer from "./reducers/contentStats";
import courseStatsReducer from "./reducers/courseStats";
import sectionStatsReducer from "./reducers/sectionStats";
import userStatsReducer from "./reducers/userStats";
import * as contentStatsSelectors from "./selectors/state/contentStats/stats";
import * as sectionStatsSelectors from "./selectors/state/sectionStats/stats";
import * as sectionStatSelectors from "./selectors/state/sectionStats/stats/stat";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_TO_USER_STATS_STATE, builder => {
  builder.registerMultiple({
    [PATH_TO_USER_STATS_STATE]: userStatsReducer,
    [PATH_TO_COURSE_STATS_STATE]: courseStatsReducer,
    [PATH_TO_SECTION_STATS_STATE]: sectionStatsReducer,
    [PATH_TO_CONTENT_STATS_STATE]: contentStatsReducer
  });
  import("./analytics");
});

// models
//User
// actions
export {
  receiveAllUserCoursesStats,
  receiveAndResetContentStudyStats,
  receiveContentStudyStats,
  receiveCourseStudyStats,
  receiveReconciledContentStudyStats,
  receiveReconciledCourseStudyStats,
  receiveReconciledSectionStudyStats,
  receiveReconciledUserStudyStats,
  receiveSectionStudyStats,
  receiveUserStudyStats
} from "./actions";
export {
  fetchAllCourseStatsActionFactory,
  fetchContentStatsActionFactory,
  fetchCourseStatActionFactory,
  fetchSectionStatActionFactory,
  fetchUserStatActionFactory
} from "./actions/fetchStates";
export { default as ContentModuleMeta } from "./models/ContentModuleMeta";
export type { ContentModuleMetaType } from "./models/ContentModuleMeta";
//Events
export { default as ModuleStudiedEvent } from "./models/ModuleStudiedEvent";
export type { ModuleStudiedEventType } from "./models/ModuleStudiedEvent";
//Content
export { ContentStat } from "./models/state/contentStats";
export type { ContentStatType } from "./models/state/contentStats";
//Course
export { CourseStat } from "./models/state/courseStats";
export type { CourseStatType } from "./models/state/courseStats";
export {
  default as SectionStatSlice,
  SectionStat
} from "./models/state/sectionStats";
//Section
export type {
  SectionStats,
  SectionStatType
} from "./models/state/sectionStats";
export { RecentlyStudiedCourse, UserStat } from "./models/state/userStats";
export type {
  RecentlyStudiedCourseType,
  UserStatServerType,
  UserStatType
} from "./models/state/userStats";
export {
  applyCompleteModuleEventToContentStat,
  transformServerContentStat
} from "./reducers/contentStats/state/stats";
export {
  applyCompleteSessionEventToCourseStat,
  transformServerCourseStat
} from "./reducers/courseStats/state/stats";
export {
  applyCompleteSessionEventToSectionStat,
  transformServerSectionStat
} from "./reducers/sectionStats/state/stats";
// logic
export {
  applyCompleteSessionEventToUserStat,
  transformServerUserStat
} from "./reducers/userStats/state/stat";
export {
  allContentStatsForCourseFetchErrored,
  allContentStatsForCourseFetchFinished,
  allContentStatsForCourseFetching,
  allContentStatsForCourseFetchSucceeded,
  allContentStatsForCourseNeedsFetching,
  allCourseStatsFetchErrored,
  allCourseStatsFetchFinished,
  allCourseStatsNeedsFetching,
  allSectionStatsForCourseFetchErrored,
  allSectionStatsForCourseFetchFinished,
  allSectionStatsForCourseFetchSucceeded,
  allSectionStatsForCourseNeedsFetching,
  courseStatFetchErrored,
  courseStatFetchFinished,
  courseStatFetchSucceeded,
  courseStatNeedsFetching,
  getContentLastScore,
  getContentLastStudied,
  getContentStat,
  getContentStats,
  getContentTimesStudied,
  getCourseLastStudied,
  getCourseProficiency,
  getCourseScore,
  getCourseSessionsCompleted,
  getCourseTotalStudyTime,
  getLastContentModuleId,
  getNumberOfModulesStudiedForCourse,
  getNumberOfSectionModuleIdsIncorrectLast,
  getSectionAverageScore,
  getSectionBestScore,
  getSectionLastScore,
  getSectionLastStudied,
  getSectionModuleIdsIncorrectLast,
  getSectionSpacing,
  getSectionsStats as getStatsForSections,
  getSectionStat,
  getSectionStats,
  getSectionTimesStudied,
  getSectionTotalStudyTime,
  getStudiedSectionIds,
  getUserLastStudied,
  getUserRecentlyStudiedCourseIds,
  getUserRecentlyStudiedCourses,
  getUserSessionModulesCorrect,
  getUserSessionModulesStudied,
  getUserSessionsCompleted,
  // users
  getUserTotalStudyTime,
  hasContentStat,
  hasSectionStat,
  lastTryForContentWasIncorrect,
  userStatsFetchErrored,
  userStatsFetchFinished,
  userStatsFetching,
  userStatsFetchSucceeded,
  userStatsNeedsFetching
} from "./selectors/state";
export { selectStudiedSectionIdsFromCourse } from "./selectors/state/selectStudiedSectionIdsFromCourse";
// reducers
export {
  userStatsReducer,
  courseStatsReducer,
  sectionStatsReducer,
  contentStatsReducer
};
// selectors
export { sectionStatsSelectors, contentStatsSelectors, sectionStatSelectors };
